import { render } from "./ImportPreview.vue?vue&type=template&id=1a39e731&scoped=true"
import script from "./ImportPreview.vue?vue&type=script&lang=ts"
export * from "./ImportPreview.vue?vue&type=script&lang=ts"

import "./ImportPreview.vue?vue&type=style&index=0&id=1a39e731&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1a39e731"

export default script